import { tns } from 'tiny-slider/src/tiny-slider';

export default {

  init() {

    let solutionGalleryList = [].slice.call(document.querySelectorAll('.solution-slider__container'));

    let solutionGalleryPrev = document.querySelector('.solution-slider__prev');
    let solutionGalleryNext = document.querySelector('.solution-slider__next');

    console.log(solutionGalleryNext);
    console.log(solutionGalleryPrev);

    solutionGalleryList.map(function(solutionGallery) {
      return tns({
          container: solutionGallery,
          items: 1,
          loop: false,
          controls: false,
          navPosition: 'bottom',
          slideBy: 'page',
          mouseDrag: true,
          gutter: 16,
          nav: true,
          prevButton: solutionGalleryPrev,
          nextButton: solutionGalleryNext,
          responsive: {
            768: {
              items: 3,
              controls: true,
            },
          },
      });
    });

    $('.fixed-logos__close').click(function() {
      $(this).closest('.fixed-logos').removeClass('active');
    });

    $(window).scroll(function() {
      $('.fixed-logos__close').closest('.fixed-logos').removeClass('active');
    });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js